export const findById = <T extends { id: number }>(
  array: T[],
  id: number,
): T | undefined => array.find((item) => item.id === id);
